import React from "react";
import { NewLicenseUploadSection } from "./NewLicenseUploadSection";
import { getParams } from "../view/urlService";
import { Key } from "lucide-react";

function NewLicenseSection({ machineData }) {

    const onCopyClick = async (value) => await navigator.clipboard.writeText(value);

    const errorMessage = getParams().message;

    return (
        //         <>
        //     <div className="row">
        //         <div className="col">
        //             <h4>{errorMessage || 'License not found'}</h4>
        //         </div>
        //         <div className="col text-right">

        //             <div className="text-secondary cursor-pointer"
        //                 data-toggle="tooltip"
        //                 onClick={() => onCopyClick(machineData.UUID)}
        //                 title="Click to copy">UUID: {machineData.UUID || 'Failed to load UUID'}
        //             </div>

        //             {machineData.vmFact &&
        //                 <div className="text-secondary cursor-pointer"
        //                     data-toggle="tooltip"
        //                     onClick={() => onCopyClick(machineData.vmFact)}
        //                     title="Click to copy">Virtual Machine: {machineData.vmFact}
        //                 </div>
        //             }

        //         </div>
        //     </div>
        //     <div className="row px-2 my-3">
        //         <NewLicenseUploadSection />
        //     </div>
        // </>

        <div className="oct_license-card-v2 w-100 mb-0">
            {/* License Header */}
            <div className="oct_license-header-v2">
                <h3>
                    <Key className="oct_icon" />
                    {errorMessage || 'License not found'}
                </h3>
                <div className="oct_license-meta">
                    <div className="oct_uuid cursor-pointer" onClick={() => onCopyClick(machineData.UUID)} title="Click to copy">
                        UUID: {machineData.UUID || 'Failed to load UUID'}
                    </div>
                    {machineData.vmFact && (
                        <div className="oct_vm cursor-pointer" onClick={() => onCopyClick(machineData.vmFact)} title="Click to copy">
                            Virtual Machine: {machineData.vmFact}
                        </div>
                    )}
                </div>
            </div>

            {/* License Key Section / Upload Section */}
            <NewLicenseUploadSection />
        </div>
    )

}

export default NewLicenseSection;